import Foodie from '../../assets/images/foodie.png'
import Giphy from '../../assets/images/Giphystud.png'
import Decentrelon from '../../assets/images/Decentrelon.png'
import Socialverse from '../../assets/images/Socialverse Final.png'
export const projectsInfo = [
    {
        image: Giphy,
        icon: '👾',
        title: 'Giphystud',
        description: 'Say it out and say it with a GIF. Build stories and create an expression while entertaining your audience',
        link: '/projects/giphy'
    },

    {
        image: Foodie,
        icon:'🍔',
        title: 'Foodie',
        description:'Enjoy fast deliveries from nearby resturants, get your food dleiveried in less than 30 mins',
        link: '/projects/foodie'
    },

    {
        image: Socialverse,
        icon:'🌍',
        title: 'Socialverse',   
        description:'Creating a Web 3.0 social media platform',
        link: '/projects/socialverse'
    },

    {
        image: Decentrelon,
        icon:'🐦',
        title: 'Freebird',
        description:'Building a decentralized Twitter for a more equitable future',
        link: '/projects/decentrelon'
    },

    
]